import { Link } from 'react-router-dom'
import Card from '@/components/ui/Card'
import UrgentRatesEditor from '@/components/admin/UrgentRatesEditor'
import type { Draft, PatchDraft } from './draft'

const CHOICES = [
  { value: 'standard', label: 'Use the standard urgent prices' },
  { value: 'custom', label: 'Own prices for this product' },
  { value: 'off', label: 'Not offered' },
] as const

/** How a rush on this product is priced: the standard table, its own rows, or not at all. */
export default function UrgentSection({ draft, patch }: { draft: Draft; patch: PatchDraft }) {
  return (
    <Card>
      <fieldset>
        {/* SectionLabel's type; a legend cannot hold its div. */}
        <legend className="mb-3 text-base font-medium text-foreground">Urgent production</legend>
        <div className="flex flex-wrap gap-x-5 gap-y-2">
          {CHOICES.map((choice) => (
            <label key={choice.value} className="flex items-center gap-2 text-sm">
              <input
                type="radio"
                name="urgent_mode"
                checked={draft.urgent_mode === choice.value}
                onChange={() =>
                  patch({
                    urgent_mode: choice.value,
                    // Own prices start from one "any speed, 1 pc and above" row.
                    urgent_tiers:
                      choice.value === 'custom' && draft.urgent_tiers.length === 0
                        ? [{ max_days: '', min_qty: '1', max_qty: '', price: '' }]
                        : draft.urgent_tiers,
                  })
                }
                className="size-4 accent-primary"
              />
              {choice.label}
            </label>
          ))}
        </div>
        {draft.urgent_mode === 'standard' && (
          <p className="mt-2 text-2xs text-muted">
            Priced from the standard table on{' '}
            <Link to="/admin/settings/sla" className="font-semibold text-brand-600 hover:underline">
              Settings &gt; SLA
            </Link>
            .
          </p>
        )}
        {draft.urgent_mode === 'off' && (
          <p className="mt-2 text-2xs text-muted">A short delivery date is made as a normal order for that date, with no urgent charge.</p>
        )}
        {draft.urgent_mode === 'custom' && (
          <div className="mt-3">
            <UrgentRatesEditor rows={draft.urgent_tiers} onChange={(urgent_tiers) => patch({ urgent_tiers })} />
          </div>
        )}
      </fieldset>
    </Card>
  )
}
